import { combineReducers, createReducer } from '@reduxjs/toolkit';

import type { Settings } from '../../types';
import { loadSettingsSuccess, updateSettingsSuccess } from '../actions';

export const general = createReducer({} as Partial<Settings>, builder => {
    builder.addCase(loadSettingsSuccess, (state, action) => action.payload);
    builder.addCase(updateSettingsSuccess, (state, action) => ({
        ...state,
        ...action.payload,
    }));
});

export const entitiesReducer = combineReducers({
    general,
});
